<app-mailer [mailHref]="mailHref" [mailTo]="mailTo" [mailSubject]="mailSubject" [mailCc]="mailCc" [matchingOffer]="matchingOffer">
</app-mailer>